import styles from "../../../../AccountingPage.module.scss";
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from "react";
import React from "react";
import { getEmployeeHistoryPayData, StatusChangeData } from "service/AccountingService";
import Notification from "utils/Notifications";
const EmployeeHystoryPayListContent = ({ render, setRender, id, dataemployee }) => {
  const { t } = useTranslation('common')

  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchHistory = async (id) => {
    try {
      setLoading(true);
      const response = await getEmployeeHistoryPayData(id);
      setHistory(response.data);
    } catch (error) {
      setHistory([]);
    } finally {
      setLoading(false);
    }
  };
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const onStatusChange = async (id) => {
    let data = await StatusChangeData(id);
    setNotify({
      isOpen: true,
      message: "Статус успешно изменен!",
      type: "success",
      sound: "success"
    });
    setRender(true)
  };

  useEffect(() => {
    if (id) fetchHistory(id);
    setRender(false);
  }, [render, id]);

  return (
    <div className={styles.content_header} style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ width: "100%" }} className={styles.print_header_selection_shah}>
        <h3 className={styles.project__h}>{t('auto.components_employeehistorycontent.k1')}</h3>
        <hr style={{ borderTop: "2px solid #444", margin: "20px 0 0 0" }} />
        <table className={styles.table__wrapper}>
          <thead className={styles.table__head}>
            <tr className={styles.table__row}>
              <th className={styles.table__item_person}>
                <span className={styles.table__title}>{t('auth.inn')}</span>
              </th>
              <th className={styles.table__item_person}>
                <span className={styles.table__title}>{t('user.last_name')}</span>
              </th>
              <th className={styles.table__item_person}>
                <span className={styles.table__title}>{t('user.first_name')}</span>
              </th>
              <th className={styles.table__item_person}>
                <span className={styles.table__title}>{t('employees.department')}</span>
              </th>
              <th className={styles.table__item_person}>
                <span className={styles.table__title}>{t('archive.col_position')}</span>
              </th>
              <th className={styles.table__item_person}>
                <span className={styles.table__title}>{t('employees.rate')}</span>
              </th>
              <th className={styles.table__item_person}>
                <span className={styles.table__title}>{t('common.status')}</span>
              </th>
              <th className={styles.table__item_person}>
                <span className={styles.table__title}>{t('distance.datetime_label')}</span>
              </th>
            </tr>
          </thead>
          <tbody className={styles.table__body}>
            <tr className={styles.table__row}>
              <td className={styles.table__item_person}>
                <span className={styles.table__title}>{dataemployee?.personaldata?.inn}</span>
              </td>
              <td className={styles.table__item_person}>
                <span className={styles.table__title}>{dataemployee?.personaldata?.surname}</span>
              </td>
              <td className={styles.table__item_person}>
                <span className={styles.table__title}>{dataemployee?.personaldata?.first_name}</span>
              </td>
              <td className={styles.table__item_person}>
                <span className={styles.table__title}>{dataemployee.department_name}</span>
              </td>
              <td className={styles.table__item_person}>
                <span className={styles.table__title}>{dataemployee.posititon_name}</span>
              </td>
              <td className={styles.table__item_person}>
                <span className={styles.table__title}>{dataemployee.stavka}</span>
              </td>
              <td className={styles.table__item_person}>
                <span
                  className={styles.table__title}
                  style={{
                    fontWeight: "700",
                    padding: "5px",
                    borderRadius: "6px",
                    display: "block",
                    textAlign: "center",
                    background:
                      dataemployee.status === "Работает"
                        ? "#5C5CFF"
                        : dataemployee.status === "Уволен(а)"
                          ? "#a00000ff"
                          : dataemployee.status === "В отпуске"
                            ? "#ec9900ff"
                            : dataemployee.status === "В командировке"
                              ? "#333333"
                              : dataemployee.status === "На больничном"
                                ? "#0a62a3"
                                : dataemployee.status === "В декретном отпуске"
                                  ? "#ffb6c1"
                                  : dataemployee.status === "В отпуске без содержания"
                                    ? "#999"
                                    : "transparent",
                    color: dataemployee.status ? "white" : "inherit",
                  }}
                >
                  {dataemployee.status || ""}
                </span>
              </td>
              <td className={styles.table__item_person}>
                <span className={styles.table__title}>
                  {new Date().toLocaleString("ru-RU", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                  })}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <h3 className={styles.project__h}>{t('auto.components_employeehistorycontent.k2')}</h3>
        <hr style={{ borderTop: "2px solid #444", margin: "20px 0 0 0" }} />
      </div>
      <hr style={{ borderTop: "2px solid #444", margin: "20px 0" }} />
      {loading ? (
        <div>{t('common.loading')}</div>
      ) : history.length === 0 ? (
        <div>{t('common.no_data')}</div>
      ) : (
        <table className={styles.table__wrapper}>
          <thead className={styles.table__head}>
            <tr className={styles.table__row}>
              <th className={styles.table__item_person}>№</th>
              <th className={styles.table__item_person}>{t('auto.components_employeehystorypaylistcontent.k1')}</th>
              <th className={styles.table__item_person}>{t('assignments.description_label')}</th>
              <th className={styles.table__item_person}>{t('auto.components_employeehystorypaylistcontent.k2')}</th>
              <th className={styles.table__item_person}>{t('archive.col_period')}</th>
              <th className={styles.table__item_person}>{t('common.status')}</th>
              
              <th className={styles.table__item_person}>{t('auto.components_employeehistorycontent.k3')}</th>
              <th className={`${styles.table__item_person} ${styles.print_none_class}`}>{t('common.actions')}</th>
            </tr>
          </thead>
          <tbody className={styles.table__body}>
            {history.map((item, index) => (
              <tr className={styles.table__row} key={item.id}>
                <td className={styles.table__item_person}>{index + 1}</td>
                
                <td className={styles.table__item_person}>
                  {item.change_type_display}
                </td>
                <td className={styles.table__item_person}>
                  {item.description || "-"}
                </td>
                <td className={styles.table__item_person}>
                  {item.new_value || "-"}
                </td>
                <td className={styles.table__item_person}>
                  {item.date_from} — {item.date_to || "н/д"}
                </td>
                <td className={styles.table__item_person}>
                  <span
                    className={styles.table__title}
                    style={{
                      fontWeight: "700",
                      padding: "5px",
                      borderRadius: "6px",
                      display: "block",
                      textAlign: "center",
                      background:
                        item.status === "Действует"
                          ? "#5C5CFF"
                          : item.status === "Период действия истек"
                            ? "#a00000ff"
                            : item.status === "Отключено"
                              ? "#5e5e5eff"
                              : "transparent",
                      color: item.status ? "white" : "inherit",
                    }}
                  >
                    {item.status || "-"}
                  </span>
                </td>
                <td className={styles.table__item_person}>
                  {item.date}
                </td>
                <td className={`${styles.table__item_person} ${styles.print_none_class}`}>
                  {item.status === "Период действия истек" ? null : (
                    <button
                      className={styles.table__button}
                      style={{
                        fontWeight: "700",
                        padding: "5px",
                        borderRadius: "6px",
                        display: "block",
                        textAlign: "center",
                        background:
                          item.status === "Действует"
                            ? "#5e5e5eff"
                            : item.status === "Отключено"
                              ? "#5C5CFF"
                              : "transparent",
                        color: item.status ? "white" : "inherit",
                        border: "none",
                        cursor: "pointer",
                        minWidth: "90px"
                      }}
                      onClick={() => {
                        if (item.status === "Действует" || item.status === "Отключено") {
                          onStatusChange(item.id);
                        }
                      }}
                    >
                      {item.status === "Действует"
                        ? "Отключить"
                        : item.status === "Отключено"
                          ? "Включить"
                          : ""}
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <Notification notify={notify} setNotify={setNotify} />
    </div>
  );
};

export default EmployeeHystoryPayListContent;